import React, { useContext } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/statistic.css'
import styles from './styles.module.scss'
import { Municipality } from 'types/Municipality'
import { CategorySelectionState } from 'components/selector/reducer'
import {
  integerCurrencyFormatter,
  integerFormatter,
  percentFormatter
} from 'lib/formatters'
import { LocaleContext } from 'contexts/locale'
import IntlMessageFormat from 'intl-messageformat'

interface Props extends Municipality, CategorySelectionState {
  numberOfMunicipalities: number
}

/**
 * Small component that provides additional details on a municipality.
 *
 * Proposed use within the list on the bottom of the map and as a popup
 * information window
 */
export const MunicipalityDetail = ({
  Belastung = 5,
  Gemeindename = 'Bern',
  Kanton = 'BE',
  Rank = 100,
  income = 150000,
  numberOfMunicipalities
}: Props) => {
  const locale = useContext(LocaleContext)
  const messages = require('./locales/' + locale + '.yml')

  const explanationFormatter = new IntlMessageFormat(
    messages['explanation'],
    locale + '-CH'
  )

  let explanation = (
    <p
      dangerouslySetInnerHTML={{
        __html: explanationFormatter.format({
          income: integerCurrencyFormatter(locale)(income),
          burden: integerCurrencyFormatter(locale)(income * Belastung * 0.01),
          rank: integerFormatter(locale)(Rank)
        })
      }}
    />
  )

  let cantonAddition = Kanton && Kanton !== '' ? ` (${Kanton})` : ''

  return (
    <div className={styles.municipalityDetail}>
      <div className={styles.header}>
        {Gemeindename}
        {cantonAddition}
      </div>
      <div className={styles.caption}>{explanation}</div>

      <div className='ui two mini statistics'>
        <div className='ui statistic belastung'>
          <div className='value'>
            {percentFormatter(locale)(Belastung * 0.01)}
          </div>
          <div className='label'>{messages['burdenLabel']}</div>
        </div>
        <div className='ui statistic rank'>
          <div className='value'>{integerFormatter(locale)(Rank)}</div>
          <div className='label'>
            sur {integerFormatter(locale)(numberOfMunicipalities)}
          </div>
        </div>
      </div>
    </div>
  )
}
